/* stylelint-disable order/properties-order */

import styled from 'styled-components';

import {
  BodyLarge,
  H2,
} from '@/core/components/Typography/Typography.styles';
import { Button } from '@/core/components/Button';

import { breakpoint } from '@/themes/breakpoints';

export const Wrapper = styled.div`
  display: flex;
  height: 532px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  padding: 40px 16px 80px 16px;
  background-image: url("/assets/images/eagle.png");
  background-position: right 165px;
  background-repeat: no-repeat;

  @media ${breakpoint.sm} {
    padding: 80px 80px 160px 80px;
  }
`;

export const Heading = styled.h2`
  ${H2}
  margin: 0;
  font-family: var(--executive-website-heading-font-family);
`;

export const Paragraph = styled.p`
  ${BodyLarge}
  margin: 0;
  margin-top: 8px;
  font-family: var(--executive-website-heading-font-family);
  text-align: center;
`;

export const StyledButton = styled(Button)`
  border-radius: 90px;
  padding: 12px 40px;
  margin-top: 64px;
`;
